import React from "react";
import Modal from 'react-responsive-modal';
import hyperloopImage from '../../imgs/hyperloop.png';
import russia from '../../imgs/ru.png';

import { Link, Switch, Route } from 'react-router-dom'

import $ from 'jquery';

import Hyperloop1 from './../docs/Hyperloop-1.js'
import Hyperloop2 from './../docs/Hyperloop-2.js';
import Hyperloop3 from './../docs/Hyperloop-3.js';


// Icons

import airmail from '../../icons/mail.svg';
import hyperloop from '../../icons/hyperloop-train.svg';

export default class extends React.Component {
  constructor(props) {
      super(props);
      this.state = {
          open : false,
          modalContentOpen: false,
      }
  }


      onOpenModal = () => {
        this.setState({ open: true });
        $.fn.fullpage.setMouseWheelScrolling(false);
        $.fn.fullpage.setAllowScrolling(false);
        console.log('hi girls');
      };

      onCloseModal = () => {
        this.setState({ open: false });
        $.fn.fullpage.setMouseWheelScrolling(true);
        $.fn.fullpage.setAllowScrolling(true);
      };

      onOpenContentModal = () => {
        this.setState({modalContentOpen: true})
      }

      onCloseContentModal = () => {
        this.setState({modalContentOpen: false})
      }
  render() {
    return (
      <section className="hyperloop section">
      <div className="container">
        <div className="row center-xs middle-xs">
          <div className="col-xs-12">
            <h1 className="heading">Hyperloop</h1>
            <img className="responsive-img hyperloop-img" src={hyperloopImage} alt="alt"/>
            <h2 className="subheading">Пятый вид транспорта после поезда, самолёта, автомобиля и корабля</h2>
            <Link to=''>
              <div onClick={this.onOpenModal} className="button">
                <span className="button__mask"/>
                <span className="button__text">Открыть</span>
                <span className="button__text button__text--bis">Открыть</span>
              </div>
            </Link>
            <Modal open={this.state.open} onClose={this.onCloseModal} little styles={
              {
                modal: {
                  padding: '2em',
                }
              }
            }>
            <div className='row center-xs modal'>
              <div className='col-xs-4'>
                <Link onClick={this.onOpenContentModal} className='link' to='/Hyperloop-1'>
                  <img alt='' className='responsive-icon' src={airmail} />
                  <p className='icon-heading'>Пневмопочта</p>
                </Link>
              </div>
              <div className='col-xs-4'>
                <Link onClick={this.onOpenContentModal} className='link' to='/Hyperloop-2'>
                  <img alt='' className='responsive-icon' src={hyperloop} />
                  <p className='icon-heading'>Hyperloop</p>
                </Link>
              </div>
              <div className='col-xs-4'>
                <Link onClick={this.onOpenContentModal} className='link' to='/Hyperloop-3'>
                  <img alt='' className='responsive-icon' src={russia} />
                  <p className='icon-heading'>Hyperloop в России</p>
                </Link>
              </div>
            </div>
            </Modal>
              <Modal open={this.state.modalContentOpen} onClose={this.onCloseContentModal}>
                <Switch>
                <Route exact path='/Hyperloop-1' component={Hyperloop1}/>
                <Route exact path='/Hyperloop-2' component={Hyperloop2}/>
                <Route exact path='/Hyperloop-3' component={Hyperloop3}/>
              </Switch>
              </Modal>
            </div>
          </div>
        </div>
      </section>
  );
  }
}



// WEBPACK FOOTER //
// ./src/components/sections/Hyperloop.js